import {create} from 'zustand';
import {StepEnum} from '../../types';
import {UseStepStoreProps} from './types';

export const useStepStore = create<UseStepStoreProps>((set, get) => ({
	step: StepEnum.BENEFICIARY_DATA,
	setStep: step => set({step}),
	resetStep: () => set({step: StepEnum.BENEFICIARY_DATA}),
	nextStep: () => set({step: get().step + 1}),
	previousStep: () => set({step: get().step - 1}),
}));
